import './Header.css';

function Header() {
    return (
        <header className="header">
            <a
                href="https://h4ck1ng.science"
                target="_blank"
                rel="noopener noreferrer"
                className="header__link"
            >
                ▸ h4ck1ng.science
            </a>

            <h1 className="header__title">
                <span className="header__title-bracket">[</span>
                onto-maker
                <span className="header__title-bracket">]</span>
            </h1>

            <div className="header__actions">
                <button className="btn btn--small">Import</button>
                <button className="btn btn--small btn--primary">Export ▾</button>
            </div>
        </header>
    );
}

export default Header;
